// extracted by mini-css-extract-plugin
export var editButton = "detailsEvent-module--edit-button--94236";
export var eventContentFooter = "detailsEvent-module--event-content-footer--890d2";
export var eventContentFooterBack = "detailsEvent-module--event-content-footer-back--c38d5";
export var eventImg = "detailsEvent-module--event-img--233cd";
export var eventPlaceIcon = "detailsEvent-module--event-place-icon--262a7";
export var eventPlaceTitle = "detailsEvent-module--event-place-title--c8369";
export var eventTitle = "detailsEvent-module--event-title--8ec83";
export var gridAriane = "detailsEvent-module--grid-ariane--06909";
export var gridContent = "detailsEvent-module--grid-content--a4a2d";
export var gridDate = "detailsEvent-module--grid-date--baaa0";
export var gridPlace = "detailsEvent-module--grid-place--46286";
export var gridResume = "detailsEvent-module--grid-resume--bd9e8";
export var gridTags = "detailsEvent-module--grid-tags--b730a";
export var gridTitle = "detailsEvent-module--grid-title--16d7f";
export var pageEvent = "detailsEvent-module--page-event--6b13c";
export var pageEventAdditionalInfos = "detailsEvent-module--page-event-additional-infos--df1ed";